import React, { useState, useEffect } from "react";
import axios from "axios";
import styled from "styled-components";
import { Col, Placeholder } from "rsuite";
import "bootstrap/dist/css/bootstrap.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSearch,
  faPlus,
  faPen,
  faTimes,
  faEye,
  faEnvelopeOpenText,
  faCheckCircle, faTrashAlt,
  faUndo, faCog, faFileExcel
} from "@fortawesome/free-solid-svg-icons";
import apiUrl from "../../apiUrlConstant";
import { Formik, Form, Field, ErrorMessage } from "formik";
import DataTable, {
  createTheme,
  defaultThemes,
} from "react-data-table-component";
import datatableOptions from "../../layout/datatableConstants";
import { Link } from "react-router-dom";
import styled1 from "styled-components";
import VoucherMailConfirmationComponent from "./VoucherMailConfirmationComponent";
import VoucherGcConfirmationComponent from "./VoucherGcConfirmationComponent";
import { Modal } from "react-bootstrap";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import { ViewLeasePdfReader } from "../../utils/ViewLeaseDocumentViewer";
import Popup from "reactjs-popup";

const TextField = styled.input`
  height: 32px;
  width: 200px;
  border-radius: 3px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border: 1px solid #e5e5e5;
  padding: 0 32px 0 16px;

  &:hover {
    cursor: pointer;
  }
`;

const ClearButton = styled.button`
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  columns={columns}
  height: 34px;
  width: 32px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  color:#003970;
`;



const StyledCell1 = styled1.div`
  &.low {
    background: green !important;
  }
  &.medium {
    background: orange;
  }
  &.high {
    background: red !important;
  }
`;

const StyledCell = ({ }) => (
  <b></b>
)
function removeVoucher(id) {
  confirmAlert({
    title: "Confirm to delete",
    message: "Are you sure you want to delete this item ?.",
    buttons: [
      {
        label: "Yes",
        onClick: () => {
          axios({
            method: "post",
            url: `${apiUrl.apiUrl.url}/voucher/delete?id=` + id,
            data: { "id": id },
          }).then(function (response) {
            window.location.href = window.location.href;
          });
        },
      },
      {
        label: "No",
        onClick: () => {
          console.log("cancel clicked");

        },
      },
    ],
  });
}
function DeleteBtn(props) {
  return (
    // (props.status == 0 && props.is_dropped == 0) && (
    <span
      className="tableActionDelete"
      onClick={() => removeVoucher(props.record_id)}
    >
      <FontAwesomeIcon icon={faTrashAlt} />
    </span>
    // )
    //   <>
    //   <span
    //     className="tableActionDelete"
    //     onClick={() => removeLease(props.id, props.ths)}
    //   >
    //     <FontAwesomeIcon icon={faTrashAlt} />
    //   </span>
    // </>
  );
}

const FilterComponent = ({ filterText, onFilter, onClear, prm, handleGrid, DownloadFile, columnsList }) => (
  <>

    {/* <button onClick={handleGrid}><FontAwesomeIcon icon={faCog} /></button> */}

    {/* <a href={apiUrl.apiUrl.url+'/lease-report/generate-summary-report?'+prm}> */}
    <button type="button" onClick={DownloadFile} className="download_button">
      Download
    </button>
    {/* </a> */}
  </>
);



//const RevenueTable = ({asset, brand, formConfig, expiry_report , expiry_lockin_report, fetchUrl, }) => {
const RevenueTable = ({ asset, brand, formConfig, expiry_report, expiry_lockin_report, fetchUrl, showExport, ths }) => {

  if (typeof formConfig == "undefined") {
    formConfig = {
      'page': 0, 'per_page': 10
    };
  }

  const [filterText, setFilterText] = React.useState("");
  const [resetPaginationToggle, setResetPaginationToggle] =
    React.useState(false);

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  //const [columns, setColumns] = useState([]);
  const [keyCounter, setkeyCounter] = useState(0);
  const [mailActivation, setMailActivation] = useState(false);
  const [gcActivation, setGcActivation] = useState(false);
  const [validityCount, setValidityCount] = useState(0);
  const [uom, setUOM] = useState('');


  const [handleMailActivationClose, setHandleMailActivationClose] = useState(false);
  const [handleGcActivationClose, sethandleGcActivationClose] = useState(false);

  const [leaseCode, setLeaseCode] = useState(0);
  const [costCenter, setCostCenterNo] = useState(0);
  const [leaseId, setLeaseId] = useState(0);
  const [voucherId, setVoucherId] = useState(0);
  const [mailConfirmationStatus, setMailConfirmationStatus] = useState(0);
  const [popupalertMessage, setpopupalertMessage] = useState(false);
  const [popupMessageContent, setpopupMessageContent] = useState("");
  const [currentDocument, setCurrentDocument] = useState("");
  const [isOpen, setIsOpen] = useState(0);
  const [gcStartDate, setGcStartDate] = useState('');
  const [gcEndDate, setGcEndDate] = useState('');

  React.useEffect(() => {
    fetchLeaseData(1);
  }, [filterText]);

  const conditionalRowStyles = [
    {
      when: row => row.toggleSelected,
      style: {
        backgroundColor: "green",
        userSelect: "none"
      }
    }
  ];
  const subHeaderComponentMemo = React.useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };


    var prm = Object.entries(formConfig).map(([key, val]) => `${key}=${val}`).join('&');
    return (
      <FilterComponent
        onFilter={(e) => {
          setFilterText(e.target.value);
        }}
        onClear={handleClear}
        filterText={filterText}
        prm={prm}
        fetchUrl={fetchUrl}
        showExport={showExport}
        DownloadFile={DownloadFile}
      />
    );
  }, [filterText, resetPaginationToggle]);

  const fetchLeaseData = async (page) => {


    let pageCnt = page ? page : 0;
    formConfig["page"] = pageCnt;
    formConfig["per_page"] = perPage;

    if (typeof expiry_report != "undefined" && expiry_report == "true") {
      formConfig['expiry_report'] = 'true';
    }

    if (typeof expiry_lockin_report != "undefined" && expiry_lockin_report == "true") {
      formConfig['expiry_lockin_report'] = 'true';
    }

    var prm = Object.entries(formConfig).map(([key, val]) => `${key}=${val}`).join('&');
    console.log(prm, "prm");


    setLoading(true);
    //asset=${asset}&brand=${brand}&page=${page}&per_page=${perPage}&delay=1&term=${filterText}`
    const response = await axios.get(
      `${fetchUrl}` + prm
    );

    if (typeof response.data.data != "undefined" && response.data.data.length > 0) {

      const updatedData = response.data.data.map(item => {
        if (item.srNo !== item.srNo) {
          return item;
        }

        return {
          ...item,
          toggleSelected: !item.toggleSelected
        };
      });

      setData(updatedData);
    } else {
      setData(response.data.data);
    }


    setTotalRows(response.data.total);
    //setColumns(eval(response.data.gridColumns))
    setkeyCounter(Math.round());
    setLoading(false);
  };

  const handlePageChange = (page) => {
    fetchLeaseData(page);
  };

  function DownloadFile() {
    var prm = Object.entries(formConfig).map(([key, val]) => `${key}=${val}`).join('&');
    var self = this;
    axios({
      method: "post",
      url: `${apiUrl.apiUrl.url + '/voucher/fetch-vouchers?' + prm + '&export=true'}`,
      data: {}
    }).then(function (response) {
      window.location.href = `${apiUrl.apiUrl.url + '/lease-report/download-file?path=' + response.data}`;
    });

  }

  const showActivationBox = (id, record_id, mail_confirmation) => {
    axios({
      method: "post",
      url: `${apiUrl.apiUrl.url}/lease-view/fetch-lease-details?leaseId=${id}`,
      data: { leaseId: id },
    }).then(function (response) {
      setLeaseId(id);
      setLeaseCode(response.data.data.lease_code);
      setCostCenterNo(response.data.data.cost_center);
      setVoucherId(record_id);
      setMailConfirmationStatus(mail_confirmation)
      setMailActivation(true);
    });
  };

  const showGcActivationBox = (id, record_id, count, uom, start, end) => {
    setGcStartDate(start)
    setGcEndDate(end);
    axios({
      method: "post",
      url: `${apiUrl.apiUrl.url}/lease-view/fetch-lease-details?leaseId=${id}`,
      data: { leaseId: id },
    }).then(function (response) {
      setLeaseId(id);
      setLeaseCode(response.data.data.lease_code);
      setCostCenterNo(response.data.data.cost_center);
      setVoucherId(record_id)
      setUOM(uom);
      setValidityCount(count)
      setGcActivation(true);

    });
  };



  const handlePerRowsChange = async (newPerPage, page) => {
    setLoading(true);
    let pageCnt = page ? page : 0;
    formConfig["page"] = pageCnt;
    formConfig["per_page"] = perPage;
    if (typeof expiry_report != "undefined") {
      formConfig['expiry_report'] = 'true';
    }
    var prm = Object.entries(formConfig).map(([key, val]) => `${key}=${val}`).join('&');
    console.log(prm, "prm");

    const response = await axios.get(
      `${fetchUrl}` + prm
    );


    // const response = response.data.data.map(item => {
    //   if (row.id !== item.id) {
    //     return item;
    //   }

    //   return {
    //     ...item,
    //     toggleSelected: !item.toggleSelected
    //   };
    // });

    //setData(updatedData);

    //`${apiUrl.apiUrl.url}/lease-report/get-all-leases?asset=${asset}&brand=${brand}&page=${page}&per_page=${newPerPage}&delay=1`
    setData(response.data.data);
    setPerPage(newPerPage);
    setLoading(false);
  };

  useEffect(() => {
    fetchLeaseData(1);
  }, []);

  const handleRowClicked = row => {
    console.log(row, "row");
    const updatedData = data.map(item => {
      if (row.id !== item.id) {
        return item;
      }

      return {
        ...item,
        toggleSelected: !item.toggleSelected
      };
    });

    setData(updatedData);
  };

  const redirectToClose = () => {
    setpopupMessageContent("");
    setpopupalertMessage(false);
  };

  function getCssClass(value) {
    if (value > 5000) return "high";
    else if (value > 500) return "medium";
    return "low";
  }

  const columns = [
    {
      name: "S.No",
      selector: "srNo",
      sortable: false,
      grow: 1,
    },
    {
      name: "Asset Name",
      selector: "assetName",
      sortable: false,
      grow: 3,
      wrap: true,
    },
    {
      name: "Lease Id",
      selector: "leaseCode",
      sortable: false,
      grow: 3,
      wrap: true,
    },
    {
      name: "Cost Center",
      selector: "costCenter",
      sortable: false,
      grow: 3,
      wrap: true,
    },
    {
      name: "Issued Month",
      selector: "issued_month",
      sortable: false,
      grow: 3,
      wrap: true,
    },

    {
      name: "Total Amt",
      selector: "total_value",
      sortable: false,
      grow: 3,
      wrap: true,
    },
    {
      name: "GC Activation Date",
      selector: "gc_activation_date_format",
      sortable: false,
      grow: 3,
      wrap: true,
    },
    {
      name: "GC Valid Till",
      selector: "gc_valid_till_format",
      sortable: false,
      grow: 3,
      wrap: true,
    },
    {
      name: "Mail Confirmation Status",
      selector: "mail_confirmation",
      sortable: false,
      grow: 2,
      wrap: true,
      cell: (record) => {
        return (
          <div>
            {record.mail_confirmation == 1 ? 'Yes' : 'No'}
          </div>
        )
      }
    },

    {
      name: "Action",
      grow: 4,
      sortable: false,
      cell: (record) => {
        return (
          <div>
            {

              (record.mail_confirmation == 1 || record.mail_confirmation == 'Yes') &&
              <span className="tableActionEdit">
                <a href="javascript:void(0)" target="_blank" onClick={(e) => {
                  e.preventDefault();
                  setCurrentDocument(record.documentUrl);
                  setIsOpen(1);
                }} >
                  {" "}
                  <FontAwesomeIcon icon={faEye} />
                </a>
              </span>
            }
            <span className="tableActionEdit" onClick={(e) => {
              showActivationBox(record.lease_id, record.record_id, record.mail_confirmation);
            }} >
              <FontAwesomeIcon icon={faEnvelopeOpenText} />
            </span>
            <span className="tableActionEdit" onClick={(e) => {
              showGcActivationBox(record.lease_id, record.record_id, record.validity_count, record.validity, record.gc_activation_date, record.gc_valid_till);
            }} >
              {/* <FontAwesomeIcon icon={faCircleCheck} /> */}
              <FontAwesomeIcon icon={faCheckCircle} />
            </span>
            <DeleteBtn
              status={record.status}
              record_id={record.record_id}
              //is_dropped={record.is_dropped}
              ths={ths}
            //setTableKey={setTableKey}            
            >
            </DeleteBtn>
          </div>
        );
      },
    },
  ];

  // subHeaderComponent={subHeaderComponentMemo}
  return (
    <>
      <div className="tableContainer revenueTable">
        <DataTable
          key={keyCounter}
          title="Vouchers"
          columns={columns}
          //direction={auto}
          data={data}
          customStyles={datatableOptions.datatableOptions.customStyle}
          progressPending={loading}
          pagination
          paginationServer
          paginationTotalRows={totalRows}
          onChangeRowsPerPage={handlePerRowsChange}
          subHeader
          subHeaderComponent={subHeaderComponentMemo}
          onChangePage={handlePageChange}
          //onRowClicked={handleRowClicked}

          //conditionalRowStyles={conditionalRowStyles}
          paginationComponentOptions={
            datatableOptions.datatableOptions.paginationOptions
          }
        />
      </div>
      <div className="row">
        <div className="col-lg-12">
          <Modal
            show={isOpen}
            onHide={setIsOpen}
            size="lg"
            className="documentModal"
          >
            <Modal.Header closeButton>
              <Modal.Title>
                <div className="container modalBreadCrumbs">
                  <div className="row">
                    <div className="col-lg-12">
                      <ul>
                        <li>Document</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="container">
                <div className="row">
                  <ViewLeasePdfReader
                    url={currentDocument}
                    pageNumber={1}
                  />
                </div>
              </div>
            </Modal.Body>
          </Modal>
        </div>
      </div>
      <Popup open={popupalertMessage} position="top center">
        {(close) => (
          <div>
            {popupMessageContent}
            <a className="close" onClick={redirectToClose}>
              &times;Close
            </a>
          </div>
        )}
      </Popup>
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <Modal
              show={mailActivation}
              size="lg"
              className="terminationFade"
              onHide={setMailActivation}
            >
              <Modal.Header closeButton>
                <Modal.Title>Mail Activation</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <VoucherMailConfirmationComponent
                  leaseCode={leaseCode}
                  costCenter={costCenter}
                  leaseId={leaseId}
                  voucherId={voucherId}
                  setMailActivation={setMailActivation}
                  setpopupMessageContent={setpopupMessageContent}
                  setpopupalertMessage={setpopupalertMessage}
                  mailConfirmationStatus={mailConfirmationStatus}
                  setkeyCounter={setkeyCounter}
                  ths={ths}
                />
              </Modal.Body>
            </Modal>

            <Modal
              show={gcActivation}
              size="lg"
              className="terminationFade"
              onHide={setGcActivation}
            >
              <Modal.Header closeButton>
                <Modal.Title>GC Activation</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <VoucherGcConfirmationComponent
                  leaseCode={leaseCode}
                  costCenter={costCenter}
                  leaseId={leaseId}
                  voucherId={voucherId}
                  uom={uom}
                  validityCount={validityCount}
                  setGcActivation={setGcActivation}
                  setpopupMessageContent={setpopupMessageContent}
                  setpopupalertMessage={setpopupalertMessage}
                  gcStartDate={gcStartDate}
                  gcEndDate={gcEndDate}
                  setkeyCounter={setkeyCounter}
                  ths={ths}
                />
              </Modal.Body>
            </Modal>
          </div>
        </div>
      </div>
    </>

  );
};
export default RevenueTable;
